import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next'; // 確保引入 useTranslation
import './UseCases.css';
import problem from '../assets/images/problem.png'; 

function UseCases() {
  const { t } = useTranslation(); // 獲取翻譯函數
  const case1Ref = useRef(null);

  const scrollToSection = (ref) => {
    ref.current.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="use-cases-page">
      <div className="case-list">
        <ul>
          {/* 將 '線上教育 - 實際案例' 替換為翻譯鍵 */}
          <li onClick={() => scrollToSection(case1Ref)}>{t('usecases.online_education.list_title')}</li>
        </ul>
      </div>
  
      <div className="case-details">
        <section ref={case1Ref} className="case-section">
          {/* 將所有文本替換為翻譯鍵 */}
          <h2>{t('usecases.online_education.title')}</h2>
  
          <h3>{t('usecases.online_education.challenge_heading')}</h3>
          <p>{t('usecases.online_education.challenge_paragraph1')}</p>
          <img src={problem} alt={t('usecases.online_education.problem_image_alt')} />
  
          <h3>{t('usecases.online_education.solution_heading')}</h3>
          <p>{t('usecases.online_education.solution_paragraph1')}</p>
          <p>{t('usecases.online_education.solution_paragraph2')}</p>
  
          <h3>{t('usecases.online_education.experience_heading')}</h3>
          <p>{t('usecases.online_education.experience_paragraph1')}</p>
          <ul>
            <li>{t('usecases.online_education.experience_example1')}</li>
            <li>{t('usecases.online_education.experience_example2')}</li>
            <li>{t('usecases.online_education.experience_example3')}</li>
          </ul>
          <p>{t('usecases.online_education.experience_paragraph2')}</p>
  
          <h3>{t('usecases.online_education.results_heading')}</h3>
          <p>{t('usecases.online_education.results_paragraph1')}</p>
          <ol>
            <li>{t('usecases.online_education.results_list1')}</li>
            <li>{t('usecases.online_education.results_list2')}</li>
            <li>{t('usecases.online_education.results_list3')}</li>
          </ol>
          <p>{t('usecases.online_education.results_conclusion')}</p>
        </section>
      </div>
    </div>
  );
}

export default UseCases;